'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _PrinterOutlined = _interopRequireDefault(require('./lib/icons/PrinterOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _PrinterOutlined;
exports.default = _default;
module.exports = _default;